declare namespace $ {

	type $mol_view__sub_shm_hitalama_benchmarks_page_metrics_details_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_labeler__title_shm_hitalama_benchmarks_page_metrics_details_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_benchmarks_page_metrics_details_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_view__sub_shm_hitalama_benchmarks_page_metrics_details_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_labeler__title_shm_hitalama_benchmarks_page_metrics_details_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_benchmarks_page_metrics_details_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_view__style_shm_hitalama_benchmarks_page_metrics_details_7 = $mol_type_enforce<
		({ 
			'maxWidth': ReturnType< $shm_hitalama_benchmarks_page_metrics_details['popup_width_max'] >,
		})  & ReturnType< $mol_view['style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_shm_hitalama_benchmarks_page_metrics_details_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pop_bubble__content_shm_hitalama_benchmarks_page_metrics_details_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_page_metrics_details['bubble_content'] >
		,
		ReturnType< $mol_pop_bubble['content'] >
	>
	type $mol_pop_bubble__height_max_shm_hitalama_benchmarks_page_metrics_details_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_benchmarks_page_metrics_details['height_max'] >
		,
		ReturnType< $mol_pop_bubble['height_max'] >
	>
	type $mol_pop_bubble__style_shm_hitalama_benchmarks_page_metrics_details_11 = $mol_type_enforce<
		({ 
			'maxWidth': ReturnType< $shm_hitalama_benchmarks_page_metrics_details['popup_width_max'] >,
		})  & ReturnType< $mol_pop_bubble['style'] >
		,
		ReturnType< $mol_pop_bubble['style'] >
	>
	export class $shm_hitalama_benchmarks_page_metrics_details extends $mol_pick {
		Icon( ): $mol_icon_information_outline
		popup_width_max( ): number
		computer( ): string
		Computer_value( ): $mol_view
		Computer_label( ): $mol_labeler
		browser( ): string
		Browser_value( ): $mol_view
		Browser_label( ): $mol_labeler
		Text( ): $mol_view
		hint( ): string
		trigger_content( ): readonly(any)[]
		Bubble( ): $mol_pop_bubble
		bubble_content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=details.view.tree.d.ts.map